import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/proceso/getExpedientesByProceso.php';

export default function getExpedientesByProceso({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}